import React from "react";
import { View } from "react-native";
import variables from "../../../../../styles/variables";

/**
 * RacecardAndResultWidgetContainer is a styled container component for racecard
 * and result widgets. It adjusts its styling based on whether it is displaying
 * results, if it's a single race, and if detailed information is required
 *
 * @prop {React.ReactNode} children - The child components to be rendered inside the container
 * @prop {boolean} isResult - Flag indicating if the container is for results view
 * @prop {boolean} isSingleRace - Flag indicating if the container is for a single race
 * @prop {boolean} isDetailed - Flag indicating if detailed styling should be applied
 *
 * @returns A styled View component wrapping the children
 */

type Props = {
  children: React.ReactNode;
  isResult?: boolean;
  isSingleRace?: boolean;
  isDetailed?: boolean;
  style?: object;
};

const { colors } = variables;
const { x50, x0 } = colors.palette.neutral;

const RacecardAndResultWidgetContainer = ({
  children,
  isResult = false,
  isSingleRace = true,
  isDetailed,
  style,
}: Props) => {
  return (
    <View
      style={[
        {
          minWidth: isSingleRace ? "100%" : 300,
          maxWidth: isSingleRace ? "100%" : 300,
          backgroundColor: isResult && !isDetailed ? x50 : x0,
          borderColor: colors.palette.neutral.x100,
          borderStyle: "solid",
          borderWidth: 1,
          borderRadius: 8,
          justifyContent: "space-between",
          padding: isDetailed ? 16 : 8,
          flexDirection: isDetailed ? "row" : "column",
        },
        isSingleRace ? {} : { aspectRatio: 300 / 204 },
        style,
      ]}
    >
      {children}
    </View>
  );
};

export default RacecardAndResultWidgetContainer;
